import { Component, OnInit, ViewChild, AfterContentInit, OnChanges, OnDestroy, DoCheck, AfterContentChecked, AfterViewChecked } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators, NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Word, SchedaIntense, Ost, Experience, SearchConfig } from '../core/models';
import { SchedeIntenseListConfig, AuthService, WMAIApiService, RouterExtService } from '../../app/core';
import { WgisService } from '../wgis/wgis.service';
import { WGisDisplayMode } from '../wgis/wgis.utils';
import { Angulartics2 } from 'angulartics2';
import { TranslateService } from '@ngx-translate/core';
import { OstListConfig } from '../core/models/ost-list-config.model';
import { BreakpointObserver } from '@angular/cdk/layout';

declare var $: any;

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html'
})

export class SearchComponent implements OnInit {

  isMapVisible = false;
  isSmallScreen: boolean = false;
  type: string;

  //modello su cui viene fatto il doppio bindig dinamico tra form html e oggetto ts
  //in searchModel ci sono i dati aggironati dal form, e se si modificano nel ts,
  //si modificano anche lato html
  searchModel: SearchConfig = new SearchConfig();

  //liste di appoggio per 'si' ed 'exp'
  siFruizioneList: Word[] = [];
  siTipologiaList: Word[] = [];
  siPresenzaSegnaleticaList: Word[] = [];
  siTematicaList: Word[] = [];
  siReteList: Word[] = [];
  siStatoFondoList: Word[] = [];
  siTipoFondoList: Word[] = [];
  siDifficoltaList: Word[] = [];
  siAccessibilitaDisabiliList: Word[] = [];

  //liste di appoggio per 'ost'
  ostFruizioneList: Word[] = [];
  ostTipologiaList: Word[] = [];
  ostPresenzaSegnaleticaList: Word[] = [];
  ostTematicaList: Word[] = [];
  ostReteList: Word[] = [];
  ostStatoFondoList: Word[] = [];
  ostTipoFondoList: Word[] = [];
  ostAccessibilitaDisabiliList: Word[] = [];
  ostDifficoltaList: Word[] = [];

  //dati comuni a tutte le ricerche
  regioniList: Word[] = [];
  languages: Word[] = [];
  distanzamin: number;
  distanzamax: number;
  duratamin: number;
  duratamax: number;
  dislivellomin: number;
  dislivellomax: number;
  altezzamaxmin: number;
  altezzamaxmax: number;
  myStep = 100;

  filtersVisible = true;
  resultsVisible = true;

  siResults: SchedaIntense[] = [];
  ostResults: Ost[] = [];
  expResults: Experience[] = [];
  resultsCount: number;
  loading = false;
  currentPage = 1;
  limit: number = 6;
  totalPages: Array<number> = [1];

  constructor(
    private formBuilder: FormBuilder,
    private activedRoute: ActivatedRoute,
    private wgisservice: WgisService,
    private wmaiservice: WMAIApiService,
    private router: Router,
    private angulartics2: Angulartics2,
    private translateService: TranslateService,
    private breakpointObserver: BreakpointObserver,
  ) {

    this.wgisservice.wgisVisible.subscribe((mode: WGisDisplayMode) => {
      this.isMapVisible = (mode !== WGisDisplayMode.Invisible);
    });

  }

  ngOnInit() {
    $('.ui.fluid.dropdown').dropdown();
    this.isMapVisible = this.wgisservice.getMapVisible();
    this.wgisservice.clearSelection();
    this.isSmallScreen = this.breakpointObserver.isMatched('(max-width: 768px)');
    if (this.isSmallScreen) this.filtersVisible = false;

    window.scrollTo(0, 0);

    //controllo se vengono passati parametri e li imposto solo se diversi da null
    this.activedRoute.queryParams.subscribe(params => {
      if(params['type'] != null)
        this.searchModel.type = params['type'];
      if(params['destinazione'] != null)
        this.searchModel.fulltext = params['destinazione'];
      if(params['fromdate'] != null)
        this.searchModel.fromdate = params['fromdate'];
      if(params['todate'] != null)
        this.searchModel.todate = params['todate'];
      if(params['fruizione'] != null)
        this.searchModel.fruizione = params['fruizione'];
      if(params['accessibilita'] != null)
        this.searchModel.accessibilita = params['accessibilita'];
      if(params['difficolta'] != null)
        this.searchModel.difficolta = params['difficolta'];
      if(params['bbox'] != null)
        this.searchModel.bbox = params['bbox'];
      if (params['mezzo'] != null) 
        this.searchModel.mezzo = params['mezzo'];

      switch (this.searchModel.mezzo) {
        case 'bici':
          this.searchModel.fruizione = '1291, 1922, 1923,1294';
          break;
        case 'cavallo':
          this.searchModel.fruizione = '1147';
          break;
        case 'piedi':
          this.searchModel.fruizione = '1295, 1296';
          break;
      }
    });
    
     
    
    //carica le liste di tutti i filtri
    this.getFiltersList();
    //imposta come ricerca di base schedeintense
    this.changeType('si');

    this.angulartics2.eventTrack.next({
      action: 'reset',
      properties: { label: 'SearchFormReset' },
    });

    this.angulartics2.eventTrack.next({
      action: 'search',
      properties: { label: 'SearchFormSubmit' },
    });

    this.angulartics2.eventTrack.next({
      action: 'setPageTo',
      properties: { label: 'SearchPagination' },
    });

    this.angulartics2.eventTrack.next({
      action: 'updateFruizioneSelected',
      properties: { label: 'SearchFruizioneSelected' },
    });

    this.angulartics2.eventTrack.next({
      action: 'updateAccessibilitaSelected',
      properties: { label: 'SearchAccessibilitaSelected' },
    });

    this.angulartics2.eventTrack.next({
      action: 'updateDifficoltaSelected',
      properties: { label: 'SearchDifficoltaSelected' },
    });

    this.angulartics2.eventTrack.next({
      action: 'showFilters',
      properties: { label: 'SearchShowFilters' },
    });

    this.angulartics2.eventTrack.next({
      action: 'showResults',
      properties: { label: 'SearchShowResults' },
    });

    this.angulartics2.eventTrack.next({
      action: 'showMap',
      properties: { label: 'SearchShowMap' },
    });

    this.angulartics2.eventTrack.next({
      action: 'displayMap',
      properties: { label: 'SearchShowMap' },
    });

  }
  /**
   * si va a richiedere lq traduzione di ogni singola parola dopo aver settato la ligua dell-app
   */
  getFiltersList(){
    this.wmaiservice.getLanguages().subscribe(data => {
      this.languages = data;
    });
    
    //funzione per recuperare la lista delle regioni
    this.wmaiservice.getWordsByKeywordLocale('*', 'regioni').subscribe(data => {
      this.regioniList = data;
    });

    //chiamate per popolare le liste con informazioni attinenti a schedeintense
    this.wmaiservice.getWordsByKeywordLocale(this.translateService.getDefaultLang(), 'fruizione').subscribe(data => {
      this.siFruizioneList = data;
    });
    this.wmaiservice.getWordsByKeywordLocale(this.translateService.getDefaultLang(), 'tipologia').subscribe(data => {
      this.siTipologiaList = data;
    });
    this.wmaiservice.getWordsByKeywordLocale(this.translateService.getDefaultLang(), 'presenza_segnaletica').subscribe(data => {
      this.siPresenzaSegnaleticaList = data;
    });
    this.wmaiservice.getWordsByKeywordLocale(this.translateService.getDefaultLang(), 'tematica').subscribe(data => {
      this.siTematicaList = data;
    });
    this.wmaiservice.getWordsByKeywordLocale(this.translateService.getDefaultLang(), 'rete').subscribe(data => {
      this.siReteList = data;
    });
    this.wmaiservice.getWordsByKeywordLocale(this.translateService.getDefaultLang(), 'statoFondo').subscribe(data => {
      this.siStatoFondoList = data;
    });
    this.wmaiservice.getWordsByKeywordLocale(this.translateService.getDefaultLang(), 'tipoFondo').subscribe(data => {
      this.siTipoFondoList = data;
    });
    this.wmaiservice.getWordsByKeywordLocale(this.translateService.getDefaultLang(), 'difficolta').subscribe(data => {
      this.siDifficoltaList = data;
    });

    //chiamate per popolare le liste con informazioni attinenti a ost
    this.wmaiservice.getWordsByKeywordLocale(this.translateService.getDefaultLang(), 'fruizione').subscribe(data => {
      this.ostFruizioneList = data;
    });
    this.wmaiservice.getWordsByKeywordLocale(this.translateService.getDefaultLang(), 'tipologia').subscribe(data => {
      this.ostTipologiaList = data;
    });
    this.wmaiservice.getWordsByKeywordLocale(this.translateService.getDefaultLang(), 'presenza_segnaletica').subscribe(data => {
      this.ostPresenzaSegnaleticaList = data;
    });
    this.wmaiservice.getWordsByKeywordLocale(this.translateService.getDefaultLang(), 'tematica').subscribe(data => {
      this.ostTematicaList = data;
    });
    this.wmaiservice.getWordsByKeywordLocale(this.translateService.getDefaultLang(), 'rete').subscribe(data => {
      this.ostReteList = data;
    });
    this.wmaiservice.getWordsByKeywordLocale(this.translateService.getDefaultLang(), 'statoFondo').subscribe(data => {
      this.ostStatoFondoList = data;
    });
    this.wmaiservice.getWordsByKeywordLocale(this.translateService.getDefaultLang(), 'tipoFondo').subscribe(data => {
      this.ostTipoFondoList = data;
    });
    this.wmaiservice.getWordsByKeywordLocale(this.translateService.getDefaultLang(), 'difficolta').subscribe(data => {
      this.ostDifficoltaList = data;
    });
    this.wmaiservice.getWordsByKeywordLocale(this.translateService.getDefaultLang(), 'accessibilita').subscribe(data => {
      this.ostAccessibilitaDisabiliList = data;
    });
    //per ora ho impostato manualmente dei valori di min e max
    this.distanzamin = 0;
    this.distanzamax = 9999;
    this.duratamin = 0;
    this.duratamax = 9999;
    this.dislivellomin = 0;
    this.dislivellomax = 9999;
    this.altezzamaxmin = 0;
    this.altezzamaxmax = 9999;

    //imposta i valori di base allo slider
    this.setSliderValue();
    this.searchModel.formatTime = 'h';
    
  }
  /** si preparano tutti i settaggi al tipo che [ passato tramite parametro]
   * @param  {string} value
   */
  changeType(value: string){
    this.wgisservice.clearSelection();
    this.siResults = [];
    this.expResults = [];
    this.ostResults = [];
    this.searchModel.type = value;
    this.setSliderValue();
    this.currentPage = 1;
    //fa partire una ricerca in basse ai parametri settatti da url
    this.submitSearch(null);
  }
  /** si cambia il formato in base al parametro passato
   * @param  {string} value
   */
  changeFormatTime(value: string){
    this.searchModel.duratastart = 0;
    this.searchModel.durataend = 9999;
    this.searchModel.formatTime = value;
  }
  /**
   * si cambia il tipo OSt in base al parametro passato
   * @param  {number} value
   */
  changeTypeOst(value: number){
    this.searchModel.ost_type = value;
    this.ostResults = [];
  }

  //funzioni per gestire i conflitti tra slider per start e end
  
  changeDurataStart(){
    //if(this.searchModel.duratastart > this.searchModel.durataend)
    //  this.searchModel.durataend = this.searchModel.duratastart + 1;
    // if(this.searchModel.formatTime == 'h' && this.searchModel.duratastart > 24)
    //   this.searchModel.duratastart = 24;
  }

  changeDurataEnd(){
    //if(this.searchModel.durataend < this.searchModel.duratastart)
    //  this.searchModel.duratastart = this.searchModel.durataend + 1;
    // if(this.searchModel.formatTime == 'h' && this.searchModel.durataend > 24)
    //   this.searchModel.durataend = 24;
  }
  /**
   * si cambia la distanza di partenza
   */
  changeDistanzaStart(){
    if(this.searchModel.distanzastart > this.searchModel.distanzaend)
      this.searchModel.distanzaend = this.searchModel.distanzastart;
  }

  /**
   * si cambia la distanza di arrivo
   */
  changeDistanzaEnd(){
    if(this.searchModel.distanzaend < this.searchModel.distanzastart)
      this.searchModel.distanzastart = this.searchModel.distanzaend;
  }

  /**
   * si cambia il dislivello di partenza
   */
  changeDislivelloStart(){
    if(this.searchModel.dislivellostart > this.searchModel.dislivelloend)
      this.searchModel.dislivelloend = this.searchModel.dislivellostart;
  }

  /**
   * si cambia il dislivello di arrivo
   */
  changeDislivelloEnd(){  
    if(this.searchModel.dislivelloend < this.searchModel.dislivellostart)
      this.searchModel.dislivellostart = this.searchModel.dislivelloend;
  }

  /**
   * si cambia l-altezza massima di partenza
   */
  changeAltezzaMaxStart(){
    if(this.searchModel.altezzamaxstart > this.searchModel.altezzamaxend)
      this.searchModel.altezzamaxend = this.searchModel.altezzamaxstart;
  }

  /**
   * si cambia l-altezza massima di arrivo
   */
  changeAltezzaMaxEnd(){
    if(this.searchModel.altezzamaxend < this.searchModel.altezzamaxstart)
      this.searchModel.altezzamaxstart = this.searchModel.altezzamaxend;
  }
  
  //setta valori di base
  setSliderValue(){
    this.searchModel.distanzastart = 0;
    this.wmaiservice.getRangeLimit( this.searchModel.type == 'ost' ? 'cache_ost' : 'cache_schede', this.searchModel.type == 'ost' ? 'lunghezza' : 'distanza').subscribe(data =>  {
      this.distanzamax = data != null ? data[0]['max'] : 9999;
    });

    this.searchModel.duratastart = 0;
    this.wmaiservice.getRangeLimit('cache_schede','durata_percorso').subscribe(data =>  {
      this.duratamax = data != null ? data[0]['max'] : 9999;
    });
    this.searchModel.dislivellostart = 0;

    this.wmaiservice.getRangeLimit(this.searchModel.type == 'ost' ? 'cache_ost' : 'cache_schede','disl_positivo').subscribe(data =>  {
      this.dislivellomax = data != null ? data[0]['max'] : 9999;
    });
    
    this.searchModel.altezzamaxstart = 0;
    this.wmaiservice.getRangeLimit('cache_schede','h_max').subscribe(data =>  {
      this.altezzamaxmax = data[0] != null ? Number(data[0]['max']) : 9999;
    });
    this.searchModel.altezzaminstart = 0;
    this.wmaiservice.getRangeLimit('cache_schede','h_min').subscribe(data =>  {
      this.altezzamaxmin = data != null ? data[0]['max'] : 9999;
    });
  }
  /** si pulisce il form
   * @param  {string} value
   */
  resetForm(value: string){
    this.siResults = [];
    this.expResults = [];
    this.ostResults = [];
    this.searchModel = new SearchConfig();
    this.setSliderValue();
    this.changeType(value);
    this.wgisservice.clearSelection();
    this.currentPage = 1;
  }
  /** in base ai parametri si va ricercare all-interno del modello, come la lista della scheda intensa
   * listaOst e la lista dell'esperienze
   * @param  {NgForm|null} form
   */
  submitSearch(form: NgForm | null){
    this.wgisservice.clearSelection();
    this.currentPage = 1;
    this.searchModel.pageNumber = 1;
    this.totalPages = [1];
    this.searchModel.locale = this.translateService.getDefaultLang();
    if ( this.searchModel.type != null) 
    {
      switch (this.searchModel.type) {
        case 'si':         
          this.getListaSchedeIntense(this.searchModel);
          break;

        case 'ost':
            this.getListaOst(this.searchModel);
          break;

        case 'exp':
            this.getListaExp(this.searchModel);
          break;

      }
    }
  }
  /**
   * si setta il numero dalla pagina in base al parametro pasato
   */
  setPageTo(pagenumber) {
    this.currentPage = pagenumber;
    this.siResults = [];
    this.expResults = [];
    this.ostResults = [];
    this.searchModel.pageNumber = pagenumber;
    if ( this.searchModel.type != null) 
    {
      switch (this.searchModel.type) {
        case 'si':         
          this.getListaSchedeIntense(this.searchModel);
          break;

        case 'ost':
            this.getListaOst(this.searchModel);
          break;

        case 'exp':
            this.getListaExp(this.searchModel);
          break;

      }
    }
    
  }

  showFilters() {
    this.filtersVisible = !this.filtersVisible;
  }

  showResults() {
    this.resultsVisible = !this.resultsVisible;
  }
  
  /** attraverso il parametro si va richiedere la lista delle schede intense e attraverso anche ad una ricerca, che 
   * in caso di risulati negativi, ritorna vuota
   * @param  {SearchConfig} query
   */
  private getListaSchedeIntense(query: SearchConfig) {
    this.siResults = [];
    this.expResults = [];
    this.ostResults = [];
    this.wgisservice.clearSelection();

    if (query) {
      this.loading = true;
      this.wmaiservice.querySearchIntense(query).subscribe(
        data => {
          if (data != null) {
            this.siResults.push(...data['data']);
            this.wgisservice.showSchedeIntense(this.siResults);
            if (data['metadata']['rowCount'] != null) {
              this.resultsCount = data['metadata']['rowCount'];
              let tmp = Math.ceil(this.resultsCount / this.limit);
              this.totalPages =  this.resultsCount <= 6 ? this.totalPages : Array.from(new Array<number>(tmp).keys()).map(x => ++x);
            }
          }
          this.loading = false;
        });
    }
  }
  /**attraverso il parametro si va richiedere la lista Ost e attraverso anche ad una ricerca, che 
   * in caso di risulati negativi, ritorna vuota
   * @param  {SearchConfig} query
   */
  private getListaOst(query: SearchConfig) {
    this.siResults = [];
    this.expResults = [];
    this.ostResults = [];
    this.wgisservice.clearSelection();

    if (query) {
      this.loading = true;
      this.wmaiservice.querySearchOst(query).subscribe(
        data => {
          if (data != null) {
            this.ostResults.push(...data['data']);
            this.wgisservice.showOsts(this.ostResults);
            if (data['metadata']['rowCount'] != null) {
              this.resultsCount = data['metadata']['rowCount'];
              let tmp = Math.ceil(this.resultsCount / this.limit);
              this.totalPages =  this.resultsCount <= 6 ? this.totalPages : Array.from(new Array<number>(tmp).keys()).map(x => ++x);
            }
          }
          this.loading = false;
        });
    }
  }
  /**attraverso il parametro si va richiedere la lista delle esperienze e attraverso anche ad una ricerca, che 
   * in caso di risulati negativi, ritorna vuota
   * @param  {SearchConfig} query
   */
  private getListaExp(query: SearchConfig) {
    this.siResults = [];
    this.ostResults = [];
    this.expResults = [];
    this.wgisservice.clearSelection();

    if (query) {
      this.loading = true;
      this.wmaiservice.querySearchEsperienze(query).subscribe(
        data => {
          if (data != null) {
            this.expResults.push(...data['data']);
            this.wgisservice.showExperiences(this.expResults);
            if (data['metadata']['rowCount'] != null) {
              this.resultsCount = data['metadata']['rowCount'];
              let tmp = Math.ceil(this.resultsCount / this.limit);
              this.totalPages =  this.resultsCount <= 6 ? this.totalPages : Array.from(new Array<number>(tmp).keys()).map(x => ++x);
            }
          }
          this.loading = false;
        });
    }
  }

  displaymap() {
    this.wgisservice.cmdToggleMap();
    this.isMapVisible = this.wgisservice.getMapVisible();
  }
}

